module.exports = __webpack_public_path__ + "assets/codeigniter.f842341b.svg";